// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2v0GC","insightsList":"newBusinessInsightsMenu_insightsList__3I3fO","active":"newBusinessInsightsMenu_active__1nXUU"};